import { css } from 'linaria';

export const cartContent = css`
  @media (--to-desktop) {
    padding: 12px 16px;
  }

  @media (--only-mobile) {
    justify-content: center;
  }
`;

export const cartContentTitle = css`
  && {
    margin-bottom: 4px;

    @media (--to-desktop) {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const cartContentPriceWrapper = css`
  display: flex;
  align-items: flex-end;
  height: 32px;
  margin-bottom: 4px;
  column-gap: 4px;

  @media (--to-desktop) {
    margin-bottom: 0;
  }
`;

export const cartContentValue = css`
  && {
    font-weight: 700;
    font-family: LMNA, Roboto, apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell,
      'Open Sans', 'Helvetica Neue', sans-serif;
  }
`;

export const cardContentCredit = css`
  && {
    width: max-content;
    height: 24px;
    padding: 3px 5px;
    border: 1px solid var(--control-minor);
    border-radius: var(--rounding-m);
  }
`;
